// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"98d0ac1b","239":"9e6d3ed9","455":"33a47217"}[chunkId] + ".chunk.js";
};